import { render } from "./UserAvatarUpload.vue?vue&type=template&id=6f8f658d"
import script from "./UserAvatarUpload.vue?vue&type=script&lang=js"
export * from "./UserAvatarUpload.vue?vue&type=script&lang=js"

import "./UserAvatarUpload.vue?vue&type=style&index=0&id=6f8f658d&lang=css"
script.render = render

export default script